import { Box, Group, Text } from '@mantine/core'
import { IconBrandWhatsapp, IconMail, IconPhone } from '@tabler/icons'

import { contactTypeUrl } from '@/lib/utils/url'
import { Contact as ContactType } from '@/types'

interface Props {
  contact: ContactType
}

const contactOptions = {
  phone: {
    label: 'Telefone',
    icon: <IconPhone color="gray" size={24} stroke={1.5} />
  },
  email: {
    label: 'Email',
    icon: <IconMail color="gray" size={24} stroke={1.5} />
  },
  whatsapp: {
    label: 'WhatsApp',
    icon: <IconBrandWhatsapp color="gray" size={24} stroke={1.5} />
  }
}

export default function ContactItem({ contact }: Props) {
  return (
    <Box mb="md">
      <Group spacing={8}>
        {contactOptions[contact.type].icon}
        <Text color="dimmed">{contactOptions[contact.type].label}</Text>
      </Group>
      <Text
        weight={700}
        size="xl"
        href={contact.url ? contact.url : contactTypeUrl(contact.type, contact.contact)}
        component="a"
        rel="noopener noreferrer"
        target="_blank"
        sx={{ wordWrap: 'break-word' }}>
        {contact.contact}
      </Text>
      {contact.description && (
        <Text color="dimmed" size="sm">
          {contact.description}
        </Text>
      )}
    </Box>
  )
}
